import axios from "axios"

export default {
    namespaced: true,

    state: {
        glossary: []
    },
    mutations: {
        setGlossary(state, array){
            state.glossary = array
        }
    },
    actions: {
        fetchData(context){
            axios({
                method: "post",
                data: {
                    query: `{
                        glossary: entries(section: "glossary", orderBy: "title ASC"){
                            id,
                            title,
                            slug
                            ... on glossary_glossary_Entry {
                                text
                            }
                        }
                    }`
                }
            }).then(function(res){
                context.commit('setGlossary', res.data.data.glossary)
            })
        }
    },
    getters: {}
}
